import NavigationTabs from "../../utils/components/NavigationTabs";
import { auth } from "../../App/routes";
import { Outlet } from "react-router";

const Settings = ({ translate }) => {
  return (
    <div className="ProjectSettings">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="row p-0">
              <div className="page page-shadow p-0">
                <div className="row">
                  <div className="col-12">
                    <NavigationTabs
                      tabs={auth.projectSettings.pages.map((item) => ({
                        id: item.id,
                        customTitle: translate(
                          `project_settings.${item.translateKey}.title`
                        ),
                        link:
                          auth.projectSettings.link +
                          (item.link ? `/${item.link}` : ""),
                      }))}
                      isUsingOutlet
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="inner-page">
                      <Outlet context={[translate]} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
